import Svg, { Path, type SvgProps } from 'react-native-svg'

export function MenuIcon(props: SvgProps) {
  return (
    <Svg fill="none" viewBox="0 0 24 24" {...props}>
      <Path
        stroke={props.color ?? 'black'}
        strokeLinecap="round"
        strokeWidth={props.strokeWidth ?? 1.5}
        d="M20 11.667H4M20 5H4m16 13.333H4"
      />
    </Svg>
  )
}
